/**
 * @file Service for holding the authenticated user
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { SettingsService } from './settings.service';
import { AuthenticationService } from './authentication.service';
import { BreezeService } from './core/breeze.service';
import { AlertsService } from './core/alerts.service';
import { TranslateService } from '@ngx-translate/core';
import { DataSet } from './core/helpers/data-set';
import { DomainService } from './domain.service';
import { EntityManagerService } from './entity-manager.service';
var UserService = /** @class */ (function (_super) {
    tslib_1.__extends(UserService, _super);
    /**
    * Creates an instance of UserService.
    * @param {HttpClient} httpClient
    * @param {SettingsService} settingsService
    * @param {AuthenticationService} authenticationService
    * @memberof UserService
    */
    function UserService(settingsService, authenticationService, domainService, alertsService, translateService, entityManagerService) {
        var _this = _super.call(this, alertsService, translateService, entityManagerService) || this;
        _this.settingsService = settingsService;
        _this.authenticationService = authenticationService;
        _this.domainService = domainService;
        return _this;
    }
    /**
     * Methode is part of Bootflow in app.module.ts
     */
    UserService.prototype.bootInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.prepareUser()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserService.prototype.prepareUser = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var claims, usernameClaim, currentUser, found;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.authenticationService.isAuthenticated()) {
                            throw new Error('Can not load user data because the current user is unauthenticated');
                        }
                        claims = this.authenticationService.getIdentityClaims();
                        usernameClaim = this.settingsService.settings.frontend.oauth.usernameClaim;
                        return [4 /*yield*/, this.loadUser()];
                    case 1:
                        currentUser = _a.sent();
                        if (!claims) {
                            this.account = currentUser.Name.toLowerCase();
                            this.fullName = currentUser.FirstName + ' ' + currentUser.LastName;
                            this.name = currentUser.FirstName;
                        }
                        else {
                            if (claims[usernameClaim] === null) {
                                throw new Error('No claim called ' + usernameClaim + ' found for the user.');
                            }
                            this.account = claims[usernameClaim].toLowerCase();
                            if (claims['given_name'] != null) {
                                this.fullName = claims['given_name'] + ' ' + claims['family_name'];
                                this.name = claims['given_name'].toLowerCase();
                            }
                            else {
                                this.fullName = this.account;
                                this.name = this.name;
                            }
                        }
                        if (!currentUser.HTML5Role) {
                            throw new Error('HTML5 Role missing for authenticated user.');
                        }
                        // Set the role (as Symagic role you change it in the application)
                        this.html5role = currentUser.HTML5Role.toLowerCase();
                        if (this.account !== currentUser.Name.toLowerCase()) {
                            throw new Error('Authenticated user does not match authorized user.');
                        }
                        found = this.settingsService.settings.frontend.languages.find(function (item) { return item.code.toLowerCase() === currentUser.Language.toLowerCase(); });
                        if (found) {
                            this.language = found.locale;
                        }
                        else {
                            this.language = this.settingsService.settings.frontend.default_language;
                            console.warn('Language "' + currentUser.Language + '" of user not supported. Default language "' + this.settingsService.settings.frontend.default_language + '" selected.');
                        }
                        // Current default
                        this.pictureUrl = 'https://s3.amazonaws.com/37assets/svn/1065-IMG_2529.jpg';
                        this.resourceOid = currentUser.Resource_Oid;
                        this.user = currentUser;
                        return [2 /*return*/];
                }
            });
        });
    };
    UserService.prototype.hasAuthenticatedUser = function () {
        return (this.user !== undefined);
    };
    UserService.prototype.getResourceOfUser = function () {
        if (!this.user || !this.user.Resource) {
            return;
        }
        return this.user.Resource;
    };
    UserService.prototype.loadUser = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dataSet;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dataSet = new DataSet();
                        dataSet.sourceName = 'CurrentUser';
                        return [4 /*yield*/, this.domainService.registerAndLoadSource('User', dataSet, dataSet.items)];
                    case 1:
                        _a.sent();
                        if (dataSet.items.length === 0) {
                            throw new Error('Can not load the Resource');
                        }
                        return [2 /*return*/, dataSet.items[0]];
                }
            });
        });
    };
    /**
     * Return a value indicating whether the action is allowed for the user's HTML5 role
     * @param {ActionConfiguration} action The action is checked for its permissions
     * @returns {boolean} True if the user may perform the action
     */
    UserService.prototype.isActionAllowed = function (action) {
        if (!this.user) {
            return false;
        }
        return !action.allowed || action.allowed.includes(this.user.HTML5Role.toLowerCase());
    };
    UserService.prototype.changeRole = function (role) {
        if (!this.settingsService.settings.frontend.roles.includes(role)) {
            return;
        }
        this.html5role = role;
    };
    return UserService;
}(BreezeService));
export { UserService };
